import { UserProfileDropdown } from './UserProfileDropdown.reducer'

export const types = Object.freeze({
  SET: '@userProfileDropdown/set'
})

export function setUserProfileDropdown(userDataProfile: UserProfileDropdown) {
  return { type: types.SET, payload: userDataProfile }
}
